/*
  Searchanise filter widget — French label overlay.

  Runs on the /fr locale (detected via the window.__CCTN_LOCALE global that
  layout/theme.liquid emits from request.locale.iso_code).

  Searchanise renders and re-renders its filter facets client-side, so we can't
  translate them via Liquid. We poll every 700ms and rewrite:
    - group titles       (.snize-product-filters-title > span[aria-hidden="true"])
    - option labels      (.snize-product-filters-list li label span.needsclick)

  Filter option `value` attributes and `data-se-facet-value-title` attributes are
  LEFT UNCHANGED — those are the English tokens Searchanise sends to its backend
  to filter products. Only visible text swaps.
*/
(function () {
  var locale = (window.__CCTN_LOCALE || document.documentElement.lang || '').toString().toLowerCase();
  if (locale.indexOf('fr') !== 0) return;

  // Filter group titles (the section headings above each checkbox list)
  var GROUP = {
    'Product type': 'Type de produit',
    'Product Category': 'Catégorie de produit',
    'Size': 'Taille',
    'Series': 'Série',
    'Surface Material': 'Matériau de surface',
    'Surface Color': 'Couleur de surface',
    'Mounting': 'Montage',
    'Magnetic': 'Magnétique',
    'Frame Material': 'Matériau du cadre',
    'Price': 'Prix',
    'Vendor': 'Fournisseur',
    'Discount': 'Réduction',
    'Collections': 'Collections',
    'Availability': 'Disponibilité',
    'Color': 'Couleur'
  };

  // Filter option values — English → French (from the user-supplied CSV)
  var OPTION = {
    // Surface Material
    'Fabric': 'Tissu',
    'Colored cork': 'liège coloré',
    'Porcelain / Fabric': 'Porcelaine / Tissu',
    'Porcelain': 'Porcelaine',
    'Cork': 'Liège',
    'Porcelain / Cork': 'Porcelaine / Liège',
    'Aluminium': 'Aluminium',
    'Lauzonite': 'Lauzonite',
    'Tempered glass': 'Verre trempé',
    'Duolox': 'Duolox',
    'Felt': 'Feutre',
    'Plastic': 'Plastique',
    'Magnet': 'Aimant',
    'Combined': 'Combiné',
    'Wood': 'Bois',
    'Vinyl': 'Vinyle',
    'Steel': 'Acier',
    'Adhesive': 'Adhésif',
    'Non Adhesive': 'Sans adhésif',
    'Non-Adhesive': 'Sans adhésif',
    'Chalk': 'Craie',
    'Cloth': 'Tissu',
    'Porcelain (2/3) / Fabric (1/3)': 'Porcelaine (2/3) / Tissu (1/3)',

    // Surface Color
    'White': 'Blanc',
    'Black': 'Noir',
    'Green': 'Vert',
    'Natural': 'Naturel',
    'White / Natural': 'Blanc / Naturel',
    'White Porcelain / 224, White': 'Porcelaine blanche / 224, White',
    'White Porcelain / 748, Bone': 'Porcelaine blanche / 748, Bone',
    'White Porcelain / 144, Eggshell': 'Porcelaine blanche / 144, Eggshell',
    'White Porcelain / 130, Wheat': 'Porcelaine blanche / 130, Wheat',
    'White Porcelain / 380, Quartz': 'Porcelaine blanche / 380, Quartz',
    'White Porcelain / 481, Pearl': 'Porcelaine blanche / 481, Pearl',
    'White Porcelain / 744, Yellow': 'Porcelaine blanche / 744, Yellow',
    'White Porcelain / 721, Lime': 'Porcelaine blanche / 721, Lime',
    'White Porcelain / 743, Fir': 'Porcelaine blanche / 743, Fir',
    'White Porcelain / 561, Verte Papier': 'Porcelaine blanche / 561, Verte Papier',
    'White Porcelain / 394, Opal': 'Porcelaine blanche / 394, Opal',
    'White Porcelain / 758, Desert Sand': 'Porcelaine blanche / 758, Desert Sand',
    'White Porcelain / 797, Sunshine': 'Porcelaine blanche / 797, Sunshine',
    'White Porcelain / 740, Sky': 'Porcelaine blanche / 740, Sky',
    'White Porcelain / 742, Teal': 'Porcelaine blanche / 742, Teal',
    'White Porcelain / 794, Coin': 'Porcelaine blanche / 794, Coin',
    'White Porcelain / 538, Silver  Papier': 'Porcelaine blanche / 538, Silver  Papier',
    'White Porcelain / 750, Cement Mix': 'Porcelaine blanche / 750, Cement Mix',
    'White Porcelain / 746, Orange': 'Porcelaine blanche / 746, Orange',
    'White Porcelain / 745, Sapphire': 'Porcelaine blanche / 745, Sapphire',
    'White Porcelain / 470, Ultramarine': 'Porcelaine blanche / 470, Ultramarine',
    'White Porcelain / 539, Blue Papier': 'Porcelaine blanche / 539, Blue Papier',
    'White Porcelain / 238, Grey Mix': 'Porcelaine blanche / 238, Grey Mix',
    'White Porcelain / 406, Silver Neutral': 'Porcelaine blanche / 406, Silver Neutral',
    'White Porcelain / 738, Cardinal': 'Porcelaine blanche / 738, Cardinal',
    'White Porcelain / 420, Cobalt': 'Porcelaine blanche / 420, Cobalt',
    'White Porcelain / 150, Wedgewood': 'Porcelaine blanche / 150, Wedgewood',
    'White Porcelain / 175, Crystal Blue': 'Porcelaine blanche / 175, Crystal Blue',
    'White Porcelain / 795, Flannel': 'Porcelaine blanche / 795, Flannel',
    'White Porcelain / 796, Moleskin': 'Porcelaine blanche / 796, Moleskin',
    'White Porcelain / 799, Red': 'Porcelaine blanche / 799, Red',
    'White Porcelain / 798, Iris': 'Porcelaine blanche / 798, Iris',
    'White Porcelain / 153, Baltic': 'Porcelaine blanche / 153, Baltic',
    'White Porcelain / 471, Stell Grey': 'Porcelaine blanche / 471, Stell Grey',
    'White Porcelain / 298, Medium Grey': 'Porcelaine blanche / 298, Medium Grey',
    'White Porcelain / 408, Black': 'Porcelaine blanche / 408, Black',
    'White Porcelain / 8888, Spirit': 'Porcelaine blanche / 8888, Spirit',
    'White Porcelain / 1276, Dim': 'Porcelaine blanche / 1276, Dim',
    'White Porcelain / 1279, Silence': 'Porcelaine blanche / 1279, Silence',
    'White Porcelain / 1282, Zen': 'Porcelaine blanche / 1282, Zen',
    'White Porcelain / 1286, Quiet': 'Porcelaine blanche / 1286, Quiet',
    'White Porcelain / 1278, Ambience': 'Porcelaine blanche / 1278, Ambience',
    'White Porcelain / 1281, Hush': 'Porcelaine blanche / 1281, Hush',
    'White Porcelain / 1284, Mute': 'Porcelaine blanche / 1284, Mute',
    'White Porcelain / 1287, Muffle': 'Porcelaine blanche / 1287, Muffle',
    'White Porcelain / 1285, Serenity': 'Porcelaine blanche / 1285, Serenity',
    'White Porcelain / 1280, Tranquility': 'Porcelaine blanche / 1280, Tranquility',
    'White Porcelain / 1283, Stillness': 'Porcelaine blanche / 1283, Stillness',
    'White Porcelain / 1289, Lull': 'Porcelaine blanche / 1289, Lull',
    'White Porcelain / 1288, Cloud': 'Porcelaine blanche / 1288, Cloud',
    'White Porcelain / 1300, Shadow': 'Porcelaine blanche / 1300, Shadow',
    'White Porcelain / 1290, Reserve': 'Porcelaine blanche / 1290, Reserve',
    'White Porcelain / 1292, Baffle': 'Porcelaine blanche / 1292, Baffle',
    'White Porcelain / 1294, Placid': 'Porcelaine blanche / 1294, Placid',
    'White Porcelain / 1296, Secret': 'Porcelaine blanche / 1296, Secret',
    'White Porcelain / 1299, Mystery': 'Porcelaine blanche / 1299, Mystery',
    'White Porcelain / 1291, Peep': 'Porcelaine blanche / 1291, Peep',
    'White Porcelain / 1293, Mellow': 'Porcelaine blanche / 1293, Mellow',
    'White Porcelain / 1295, Chant': 'Porcelaine blanche / 1295, Chant',
    'White Porcelain / 1297, Mum': 'Porcelaine blanche / 1297, Mum',

    // Series
    'Series 2000': 'Série 2000',
    'Series 5000': 'Série 5000',
    'Series 3000': 'Série 3000',
    'Series 8000': 'Série 8000',
    'Series 1000': 'Série 1000',
    'Series 750F': 'Série 750F',
    'Series 755F': 'Série 755F',
    'Series 670': 'Série 670',
    'Series 680': 'Série 680',
    'Series 640': 'Série 640',
    'Series 8500': 'Série 8500',
    'Series 910': 'Série 910',
    'Series 900': 'Série 900',
    'Series 40': 'Série 40',
    'Series 70': 'Série 70',
    'Series 80': 'Série 80',
    'Series 714': 'Série 714',
    'White Glass Board': 'Tableau en verre blanc',
    'Series 555': 'Série 555',
    'Series 715': 'Série 715',
    'Series 712': 'Série 712',
    'Series 713': 'Série 713',
    'Maprail 10R': 'Maprail 10R',
    'Magnets': 'Aimants',
    'Series 755': 'Série 755',
    'Series 716': 'Série 716',
    'Series 717': 'Série 717',
    'Magnet strip': 'bande magnétique',
    'Series 750': 'Série 750',
    'Classic white glass mobile board': 'Tableau mobile classique en verre blanc',
    'Angled White Glass Mobile Board': 'Tableau mobile en verre blanc incliné',
    'Series 718': 'Série 718',
    'L trim': 'garniture L',
    'Luma projection screen': 'Écran de projection Luma',
    'Portable Series': 'Série portable',
    'Series 950': 'Série 950',
    'Flat bar': 'Barre plate',
    'Magnetic pen tray': 'Porte-stylo magnétique',
    'Glass easel': 'Chevalet en verre',
    'Porcelain panel': 'panneau en porcelaine',

    // Product Category
    'Professional': 'Professionnel',
    'Economic': 'Économique',

    // Mounting
    'Z-Bar / Brackets': 'Z-Bar / Supports',
    'Z-Bar': 'Z-Bar',
    'Casters': 'Roulettes',
    'Screws': 'Vis',
    'Levelers': 'Niveleurs',
    'Screwed': 'Vissé',
    'V-Bar': 'V-Bar',
    'Edge grip': 'Edge grip',
    'Casters for carpet': 'Roulettes pour moquette',
    'Casters for ceramic': 'Roulettes pour céramique',
    'Hooks': 'Crochets',

    // Magnetic
    'No': 'Non',
    'Yes': 'Oui',

    // Frame Material
    'Anodized aluminium': 'Aluminium anodisé',
    'Frameless': 'sans cadre',
    'Melamine': 'mélamine',
    'Plastic Laminate': 'Stratifié plastique',
    'Wood / Aluminium': 'Bois / Aluminium',
    'Plastic Laminate / Aluminium': 'Stratifié plastique / Aluminium'
  };

  function pass() {
    var blocks = document.getElementsByClassName('snize-product-filters-block');
    if (!blocks.length) return;

    // Group titles
    var titleNodes = document.querySelectorAll('.snize-product-filters-title > span[aria-hidden="true"]');
    for (var t = 0; t < titleNodes.length; t++) {
      var el = titleNodes[t];
      if (el.dataset.cctnTr === '1') continue;
      // First text-node child is the label. Keep sibling elements (count + reset btn) intact.
      var textNode = null;
      for (var k = 0; k < el.childNodes.length; k++) {
        var n = el.childNodes[k];
        if (n.nodeType === 3 && (n.nodeValue || '').trim()) { textNode = n; break; }
      }
      if (!textNode) continue;
      var raw = textNode.nodeValue.trim();
      var frT = GROUP[raw];
      if (!frT) continue;
      // Preserve trailing space so adjacent inline elements don't run into the label
      textNode.nodeValue = frT + ' ';
      el.dataset.cctnTr = '1';
    }

    // Option labels
    var lists = document.getElementsByClassName('snize-product-filters-list');
    for (var i = 0; i < lists.length; i++) {
      var lis = lists[i].getElementsByTagName('li');
      for (var j = 0; j < lis.length; j++) {
        if (lis[j].dataset.cctnTr === '1') continue;
        var input = lis[j].getElementsByTagName('input')[0];
        if (!input) continue;
        var val = (input.getAttribute('data-se-facet-value-title') || input.value || '').trim();
        var fr = OPTION[val];
        if (!fr) continue;
        // Find the text-carrying <span class="needsclick"> that is a direct
        // child of <label> (not the inner checkbox span).
        var spans = lis[j].getElementsByTagName('span');
        for (var s = 0; s < spans.length; s++) {
          var sp = spans[s];
          if (sp.parentNode && sp.parentNode.tagName === 'LABEL' &&
              sp.firstChild && sp.firstChild.nodeType === 3 &&
              sp.firstChild.nodeValue && sp.firstChild.nodeValue.trim()) {
            sp.firstChild.nodeValue = fr;
            lis[j].dataset.cctnTr = '1';
            break;
          }
        }
      }
    }
  }

  if (document.readyState !== 'loading') pass();
  document.addEventListener('DOMContentLoaded', pass);
  setInterval(pass, 700);
})();
